<template>
    <toolbar-option type="stacked">
        <template slot="secondary">
            <dropdown
                :value="state"
                :options="stateOptions"
                native
                @input="onStateInput"
            />
        </template>

        <template slot="primary">
            <slider
                :value="sliderIndex"
                :values="themeObjectValues"
                show-decimal
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option-slider';

const DEFAULT_STATE = 'default';

export default {
    name: 'opacity',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Opacity',
            tailwindDefinitionProp: 'opacity',

            state: DEFAULT_STATE,
            stateOptions: [
                { text: 'Default', value: 'default' },
                { text: 'On Hover', value: 'hover' },
            ],
        };
    },

    computed: {
        states() {
            return this.stateOptions.map(opt => opt.value);
        },
    },

    watch: {
        deviceMode() {
            this.setState();
        },

        state() {
            this.setSlider();
        },

        selectedElements: {
            handler() {
                this.setState();
            },
            immediate: true,
        },
    },

    methods: {
        setState() {
            this.state = this.flexClassDefinition.state || DEFAULT_STATE;
        },

        onStateInput(newState) {
            this.state = newState;
        },
    },
};
</script>
